import React, { useRef } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import '../../styles/JobOrderReport.css';
import logo from "../../images/BPMC_Logo.png";

// Calculate the current date outside the component
const currentDate = new Date().toLocaleDateString("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric"
});

const generateReports = async (reportData) => { 
    const element = document.createElement('div');
    element.className = 'report-container';  // Add this line to apply the styling class      

    element.innerHTML = `<div className="logo-container" style="text-align: center; margin: 20px 0;">
          <img src=${logo} alt="Company Logo" className="logo" style="width: 300px; height: auto;"/>
        </div>

    
        <div className="header" style="text-align: center; margin-bottom: 20px;">
          <h2 style="margin: 0; font-size: 24px;">BOAZ Pest Management Corp.</h2>     
          <h3 style="margin: 5px 0; font-size: 20px; font-weight: bold;"><strong>Accomplishment Report</strong></h3>
          <p style="font-size: 12px; color: #555;">Form#: ACT-ACC-OP-03F4</p>
        </div>

    
        <div className="date-section" style="text-align: right; font-size: 16px; margin-bottom: 20px;">
          <p><strong>Date:</strong> ${currentDate}</p>
        </div>

       
        <div className="greeting" style="margin-bottom: 20px; line-height: 1.6;">
          <p><strong>Sir/Ma’am,</strong></p>
          <p>Good day!</p>
          <p>We are pleased to send you our <strong>Accomplishment Report</strong> for the visit done on the date below.</p>
          <p>We thank you and please let us know if you have questions.</p>
          <p>Sincerely,</p>
          <p><strong>BOAZ Pest Control Services – Accounts Team</strong></p>
        </div>

       
        <h4 className="table-heading" style="font-size: 18px; font-weight: bold; margin-top: 20px; margin-bottom: 10px; text-align: center;">Accomplishment Summary Report</h4>
        <table className="summary-table" style="width: 100%; border-collapse: collapse; margin: 10px 0;">
          <tbody>
            <tr>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;><strong>Customer Number:</strong></td>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;>${reportData.clientId}</td>
            </tr>
            <tr>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;><strong>Client:</strong></td>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;>${reportData.client_name}</td>
            </tr>
            <tr>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;><strong>Date and Time of Treatment:</strong></td>
              <td style=padding: 10px; border: 1px solid #000; font-size: 14px;>${reportData.actual_end_date} ${reportData.actual_end_time}</td>
            </tr>
          </tbody>
        </table>

        
        <h4 className="table-heading" style="font-size: 18px; font-weight: bold; margin-top: 20px; margin-bottom: 10px; text-align: center;">Treatment Details</h4>
        <table className="details-table" style="width: 100%; border-collapse: collapse; margin: 10px 0;">
          <tbody>
            <tr>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;"><strong>Treatment Description:</strong></td>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;">${reportData.treatment_description}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;"><strong>Chemical Used:</strong></td>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;">${reportData.chemical_used}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;"><strong>Treatment Type:</strong></td>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;">${reportData.treatment_type}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;"><strong>Payment Status:</strong></td>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;">${reportData.payment_status}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;"><strong>Technicians:</strong></td>
              <td style="padding: 10px; border: 1px solid #000;  font-size: 14px;">${reportData.technicians.map(tech => `${tech.firstname} ${tech.lastname}`).join(', ')}</td>
            </tr>
          </tbody>
        </table>

        
        <div className="findings-recommendations" style="margin-top: 20px;">
          <h4 style="font-size: 18px; margin: 15px 0 10px;">Findings</h4>
          <p>${reportData.findings}</p>
          <h4 style="font-size: 18px; margin: 15px 0 10px;">Recommendations</h4>
          <p>${reportData.recommendations}</p>
        </div>

       
        <div className="logo-container">
          <img src="path-to-logo.png" alt="Company Logo" className="logo" />
        </div>
      </div>      
    </div>`;
    // Example content
    document.body.appendChild(element);
    try {
      // Generate the canvas and capture the element, ignoring iframes
    const canvas = await html2canvas(element, {
      scale: 1.5, // Reduce scale for smaller image size
      useCORS: true, // Enables CORS for external images
      ignoreElements: (element) => element.tagName === "IFRAME", // Ignores iframes
    });
    const imgData = canvas.toDataURL('image/jpeg', '0.6');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, 'JPEG', 10, 10, imgWidth, imgHeight, undefined, 'FAST'); // Fast compression mode
    pdf.save('Accomplishment_Report.pdf'); // Save 
    const pdfBlob = pdf.output("blob"); // Returns a Blob for S3 upload
    return pdfBlob;
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      // Clean up by removing the temporary element
      document.body.removeChild(element);
    }
  };
  
 export default generateReports;
